import { ViewStream, safeClone } from 'spyne';
import { DeckBlockTraits } from 'traits/deck/deck-block-traits.js';

export class DeckBlockView extends ViewStream {
  constructor(props = {}) {
    props.data = safeClone(props.data);
    const kind = DeckBlockTraits.deckBlock$PrepareData(
      props.data,
      props.slideLayout,
    );

    props.tagName = DeckBlockTraits.deckBlock$GetTagName(kind);
    props.class = DeckBlockTraits.deckBlock$GetClass(kind, props.data);
    props.dataset = { blockType: props.data.type, blockKind: kind };
    props.traits = [DeckBlockTraits];
    props.template = DeckBlockTraits.deckBlock$GetTemplate(kind);

    super(props);
  }

  onRendered() {
    this.deckBlock$onRendered();
  }
}
